module.exports = __webpack_public_path__ + "static/img/fire.b0d02ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/fire.png
// module id = ltQY
// module chunks = 1